/* eslint-disable react/no-unused-prop-types */
import React, { useContext } from 'react';
import { FlexboxGrid, Panel, Col } from 'rsuite';
import formatCurrency from '~/utils/formatCurrency';
import { DarkModeContext } from '~/common/contexts/darkMode';
import PropTypes from 'prop-types';
import { MdOutlinePeopleOutline } from 'react-icons/md';
import { GiConfirmed } from "react-icons/gi";
import theme from '../../../../styles/theme';
import { IconWrapper } from './styles';

function CardTotais({ numeroProfissionais, totalContratado }) {
  const { toggleMode } = useContext(DarkModeContext)

  const icon = (titulo) => {
    if (titulo === 'Nº de Profissionais: ') {
      return (
        <IconWrapper>
          <MdOutlinePeopleOutline size='30px' />
        </IconWrapper>
      )
    }
    return (
      <IconWrapper color='#34A853' background='#E6F4EA'>
        <GiConfirmed size='30px' />
      </IconWrapper>
    )
  }
  const Card = ({ titulo, valor }) => (
    <Panel shaded style={{ backgroundColor: toggleMode ? theme.rsuiteGray : 'white', width: '100%', display: 'flex', alignItems: 'center', gap: '16px', padding: '10px', borderRadius: '8px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexDirection: 'column' }}>
        <IconWrapper>
          {icon(titulo)}
        </IconWrapper>
        <h6 style={{ color: toggleMode ? 'gray' : theme.darkGray }}>
          {titulo}
          <spam style={{ color: toggleMode ? '#1675e0' : theme.primaryColor }}>{valor}</spam>
        </h6>
      </div>
    </Panel>
  );
  return (
    <FlexboxGrid justify="start" style={{ padding: '20px', gap: 10 }}>
      <FlexboxGrid.Item componentClass={Col}>
        <Card valor={numeroProfissionais} titulo="Nº de Profissionais: " />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item componentClass={Col}>
        <Card
          valor={formatCurrency(totalContratado)}
          titulo="Total Contratado: "
        />
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
}

CardTotais.propTypes = {
  numeroProfissionais: PropTypes.func.isRequired,
  totalContratado: PropTypes.string.isRequired,
  titulo: PropTypes.string.isRequired,
  valor: PropTypes.string.isRequired,
};
export default CardTotais;
